import React, { useEffect, useState } from 'react';
import { getMyHealthSharing, recordHealthSharing, HEALTH_SHARING_TEXT } from '../services/healthSharingService';
import { Button, Dialog } from './bodystats/parts';
import { colors } from '../theme';
import { claimPromptSlot } from '../utils/promptOncePerVisit';

// Asked once of clients who have not answered (everyone who joined before 18 October 2026, or whose
// sign-up answer was not saved), on the Workout screen. Either answer is recorded (migration 083) and the
// question is not asked again; it can be changed any time in Settings. Says nothing if it cannot check.
// It takes the visit's one pop-up slot, so the add-to-home-screen guide does not open over it; if the
// guide is already on screen, it is asked on a later visit (Codex's task 020 review, 21 October 2026).
export default function HealthSharingPrompt({ userId }) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) return undefined;
    let gone = false;
    getMyHealthSharing(userId)
      .then((s) => { if (!gone && (!s.answered || !s.current) && claimPromptSlot('health-sharing')) setOpen(true); })
      .catch(() => {});
    return () => { gone = true; };
  }, [userId]);

  if (!open) return null;
  const answer = async (shares) => {
    setSaving(true);
    setError(null);
    try {
      await recordHealthSharing(userId, shares, 'prompt');
      setOpen(false);
    } catch (e) {
      setError('Your answer was not saved. Check your connection and try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog title="Your health information" onClose={() => setOpen(false)}>
      <div style={{ display: 'grid', gap: 12, fontSize: 15, lineHeight: 1.6 }}>
        <p style={{ margin: 0 }}>
          Your coach and Cipher's lead coach use your health answers and body scans to adapt your training. We now ask everyone to agree to this separately.
        </p>
        <p style={{ margin: 0, color: colors.textMuted, fontSize: 14 }}>{HEALTH_SHARING_TEXT}</p>
        <p style={{ margin: 0, color: colors.textMuted, fontSize: 14 }}>
          If you keep it private, they still see your training and weight, but not your health answers or body scans.
        </p>
        {error && <div role="alert" style={{ fontSize: 13, color: colors.text, borderLeft: `2px solid ${colors.text}`, paddingLeft: 6 }}>{error}</div>}
        <Button kind="primary" onClick={() => answer(true)} disabled={saving}>I agree</Button>
        <Button onClick={() => answer(false)} disabled={saving}>Keep it private</Button>
      </div>
    </Dialog>
  );
}
